import * as React from "react";
import type { SVGProps } from "react";
const SvgDocumentPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.1 10.62H5.91V18h1.75v-2.8h.41c1.36 0 1.89-.73 1.89-2.09v-.49c0-1.24-.58-2-1.86-2m-.3 3.17h-.14v-1.87h.13c.25 0 .4.1.4.5v.79c0 .44-.1.58-.39.58M10.46 10.62h1.92c1.44 0 2.13.56 2.13 2.27v2.69c0 1.53-.39 2.37-1.88 2.37h-2.17zm1.75 6h.16c.27 0 .37-.15.37-.48v-3.73c0-.39-.14-.48-.38-.48h-.15z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.29 10.62h-3.23v7.32h1.75v-3h1.36v-1.45h-1.36v-1.43h1.48z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 22H4L3 7a1 1 0 0 1 .29-.71l4-4A1 1 0 0 1 8 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1M5 20V8h3a1 1 0 0 0 1-1V4h10v16zM7 6v-.59L6.41 6z"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M4 22 3 7.002V21a1 1 0 0 0 1 1" />
  </svg>
);
export default SvgDocumentPdf;
